import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Input } from '@/components/ui/Input'
import { useSession } from '@/lib/session'
import { useAthletes } from '@/hooks/useAthletes'
import { Logo } from '@/components/Logo'

export default function Splash() {
  const navigate = useNavigate()
  const { signOut } = useSession()
  const { data: athletes = [], isLoading } = useAthletes(true)
  const [query, setQuery] = useState('')

  const results = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return []
    return athletes.filter((a) => a.name.toLowerCase().includes(q)).slice(0, 8)
  }, [query, athletes])

  return (
    <div className="hero-glow relative flex min-h-full flex-col items-center justify-center px-6 py-16">
      {/* Signed-in device controls */}
      <div className="absolute right-4 top-4 flex items-center gap-3">
        <button
          onClick={() => navigate('/coach')}
          className="font-condensed text-[11px] uppercase tracking-[0.2em] text-muted hover:text-gold"
        >
          Coach Dashboard
        </button>
        <span className="text-subtle">·</span>
        <button
          onClick={async () => {
            await signOut()
            navigate('/login')
          }}
          className="font-condensed text-[11px] uppercase tracking-[0.2em] text-muted hover:text-gold"
        >
          Sign out
        </button>
      </div>

      <div className="w-full max-w-md animate-fade-in">
        {/* Wordmark */}
        <div className="mb-12 text-center">
          <Logo className="mx-auto h-20 sm:h-24" />
          <p className="mt-4 font-condensed text-xs uppercase tracking-[0.4em] text-muted">
            Performance Training
          </p>
        </div>

        {/* Athlete search */}
        <label className="mb-2 block font-condensed text-[11px] uppercase tracking-[0.25em] text-muted">
          Find your name
        </label>
        <Input
          autoFocus
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={isLoading ? 'Loading roster…' : 'Start typing…'}
          className="font-condensed text-lg font-semibold"
        />

        {/* Results */}
        {query && (
          <div className="mt-3 overflow-hidden rounded-card border border-border bg-surface-2 shadow-card animate-scale-in">
            {results.length === 0 ? (
              <p className="px-4 py-4 text-sm italic text-muted">No athletes found</p>
            ) : (
              results.map((a) => (
                <button
                  key={a.id}
                  onClick={() => navigate(`/athlete/${a.id}`)}
                  className="flex w-full items-center justify-between border-b border-border px-4 py-3.5 text-left transition-colors last:border-0 hover:bg-surface-3"
                >
                  <span className="font-condensed text-lg font-bold tracking-wide">{a.name}</span>
                  <span className="text-xs text-muted">Week {a.current_week ?? 1}</span>
                </button>
              ))
            )}
          </div>
        )}
      </div>

      <p className="absolute bottom-6 font-condensed text-[10px] uppercase tracking-[0.3em] text-subtle">
        v2.0 — rebuild preview
      </p>
    </div>
  )
}
